import React from "react";
import { BrowserRouter as Router, Navigate, Routes, Route } from "react-router-dom";
import Home from "../views/Home";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/mosaic" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
};

export default App;
